import {css} from '@linaria/core';
import {styled} from '@linaria/react';
import React from 'react';
import {mediaDesktopAndUp} from '../../../../constants/customMedia';
import {FONT_SIZES} from '../../../../constants/typography';
import {GridItem, LinksGrid} from './LinksGrid';
import {LinksGridContainer} from './LinksGridContainer';

export interface LinkContainerProps {
  dataTestId: string;
  onLinkItemClick: () => void;
  sections: Array<{
    footer?: {label: string; url: {url: string}};
    headline?: string;
    items: GridItem[];
  }>;
}

export const LinkContainer: React.FC<LinkContainerProps> = ({
  dataTestId,
  onLinkItemClick,
  sections,
}) => {
  const maxRowsPerLinkSectionInTabletView =
    {
      1: 3,
      2: 4,
    }[sections.length] ?? 6;

  return (
    <Wrapper data-testid={dataTestId}>
      {sections.map(({items, footer, headline}, index) => (
        <LinksGridContainer
          key={`linkContainer-${index}`}
          className={ItemClass}
          footer={footer}
          headline={headline}
          onLinkItemClick={onLinkItemClick}
        >
          <LinksGrid
            gridItems={items}
            onLinkItemClick={onLinkItemClick}
            maxRowsPerLinkSectionInTabletView={
              maxRowsPerLinkSectionInTabletView
            }
          />
        </LinksGridContainer>
      ))}
    </Wrapper>
  );
};

const ItemClass = css``;

const Wrapper = styled.div`
  display: flex;
  gap: 10px;
  font-size: ${FONT_SIZES.px12};

  .${ItemClass} {
    &:not(:last-child) {
      margin-right: 20px;

      @media ${mediaDesktopAndUp} {
        margin-right: 30px;
      }
    }
  }
`;
